import React from 'react';
import { Link } from 'react-router-dom';
import DocModuleIcon from './DocModuleIcon';

const DocGuideView = ({ guide, accent, breadcrumb, backTo, backLabel, moduleId }) => (
  <article className="doc-page-card doc-guide-card" style={{ '--doc-accent': accent }}>
    <nav className="doc-breadcrumb" aria-label="Breadcrumb">
      {breadcrumb}
    </nav>

    <header className="doc-module-header">
      {moduleId && <DocModuleIcon moduleId={moduleId} variant="hero" accent={accent} />}
      <div className="flex-grow-1">
        {guide.stepNumber != null && (
          <span className="doc-guide-step-pill">Step {guide.stepNumber}</span>
        )}
        <h2 className="doc-section-title mb-1">{guide.title}</h2>
        <p className="doc-module-summary mb-0">{guide.summary}</p>
      </div>
    </header>

    <div className="doc-sidebar-path">
      <strong>Where in the app</strong>
      <span>{guide.sidebarPath}</span>
    </div>

    {guide.prerequisites?.length > 0 && (
      <div className="doc-prereq-row">
        <strong>Before you start</strong>
        <ul className="doc-prereq-list">
          {guide.prerequisites.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    )}

    {guide.steps.map((block, blockIndex) => (
      <div key={block.heading} className="doc-guide-step-block">
        <h3 className="doc-guide-step-heading">
          <span className="doc-guide-step-index">{blockIndex + 1}</span>
          {block.heading}
        </h3>
        <ul className="doc-guide-points">
          {block.points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      </div>
    ))}

    {guide.tips?.length > 0 && (
      <div className="doc-tips-box">
        <strong>Tips</strong>
        <ul>
          {guide.tips.map((tip) => (
            <li key={tip}>{tip}</li>
          ))}
        </ul>
      </div>
    )}

    {backTo && (
      <div className="doc-page-footer-nav">
        <Link to={backTo} className="doc-back-page-link">
          &larr; {backLabel || 'Back'}
        </Link>
      </div>
    )}
  </article>
);

export default DocGuideView;
